import useMetaTags from '../../hooks/useMetaTags'
import {
  AssistanceSection,
  BenefitSection,
  FAQ,
  LargeData,
  roleWriting,
} from "../../Data/All_Services_Data/iosServiceData";
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Handle_Largedata_section from '../../component/Services_Component/Handle_Largedata_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';

const IosAppDevelopmentServices = () => {
    useMetaTags({
        title:
            "Professional iOS App Development Services | Warrgyizmorsch Team",
        description:
            "Warrgyizmorsch delivers innovative iOS app development services for startups and enterprises. Build fast, secure, and engaging iPhone apps with our expert developers.",
        keywords:
            "ios app development services,ios app development companies,ios application development services,ios mobile app development companies,ios mobile app development services,ios mobile development company,ios app development firm,ios mobile application development company,ios mobile application development services,iphone app development company,iphone app development firm,iphone application development agency",
    });
    return (
        <>
            <section
                className=""
                style={{
                    backgroundImage: `url('assets/img/service/serviceD.jpg')`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                }}
                id="service-sec"
            >
                <div className="round-container pt-5">
                    <div className="container">
                        <div className="title-area text-center">
                            <span className="sub-title text-white">OUR SERVICES</span>
                            <h1 className="sec-title text-white">
                                iOS App Development Services
                            </h1>
                        </div>
                    </div>
                </div>
            </section>
            <section className="space-extra-bottom">
                <div className="page-single">
                    <div className="page-content">
                        <style>{`
                        .header-section{
                            display: flex;
                            align-items: center;
                            gap: 20px;
                            margin-bottom: 30px;
                        }
                        .header-section img{
                            height: 400px;
                        }
                        .header-section p{
                            text-align: left;
                        }

                        @media only screen and (max-width: 990px) {
                            .header-section{
                                flex-direction: column;
                            }
                            .header-section img{
                                height: 200px;
                            }
                            .header-section p{
                                text-align: center;
                            }
                        }
                    `}</style>
                        {/* Intro part  */}
                        <div
                            className="header-section container"
                            style={{ marginTop: "20px" }}
                        >
                            <img
                                src="assets/img/icon/mobile app.jpg"
                                loading="lazy"
                                alt="heading_image"
                            />
                            <div>
                                <p>
                                    We at Warrgyizmorsch are iOS App Development Services professionals that develop excellent apps that symbolize your brand's true identity. From conceptualization to post-launch, we provide end-to-end care for your business development. We have professional developers who design and deliver high-quality apps on the Apple platform, providing you with seamless user experience on iPhones, iPads, and Apple Watches. With the newest tools like Swift and Xcode, we create strong, scalable, and responsive solutions that best meet your goals. With Warrgyizmorsch, you have a dedicated ally working to assist you in translating your vision into successful mobile experiences.
                                </p>
                            </div>
                        </div>

                        <Benefits_section data={BenefitSection} />

                        <Role_writing data={roleWriting} />

                        <Handle_Largedata_section LargeData={LargeData} />

                        <Assistance_section data={AssistanceSection} />

                        <FAQ_section data={FAQ} />
                        
                    </div>
                </div>
            </section>
            <div className="scroll-top">
                <svg
                    className="progress-circle svg-content"
                    width="100%"
                    height="100%"
                    viewBox="-1 -1 102 102"
                >
                    <path
                        d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
                        style={{
                            transition: "stroke-dashoffset 10ms linear 0s",
                            strokeDasharray: "307.919, 307.919",
                            strokeDashoffset: "307.919",
                        }}
                    ></path>
                </svg>
            </div>
        </>
    )
}

export default IosAppDevelopmentServices